import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a phone number string into (XXX) XXX-XXXX format.
 * Handles 10-digit raw numbers, 7-digit numbers, and passes through already-formatted values.
 *
 * Usage: {{ phoneValue | phoneFormat }}
 */
@Pipe({ name: 'phoneFormat' })
export class PhoneFormatPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';

    const digits = value.replace(/\D/g, '');

    if (digits.length === 10) {
      return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    }

    if (digits.length === 11 && digits.startsWith('1')) {
      return `(${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    }

    if (digits.length === 7) {
      return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    }

    return value;
  }
}
